const messages = {
    en: {
        title: 'Configure your TPaaS meeting',
        need_login: 'You need to log in first',
        username: 'Username',
        password: 'Password',
        login: 'Login',
        logout: 'Logout',
        use_this_room: 'Use this Room',
        record_meeting: 'Record the meeting',
        call_members: 'Autocall registered video users',
        use_pin: 'Set a PIN to secure the meeting',
        participants: 'Participants',
        create_meeting: 'Create video meeting',
        meeting_reserved: 'This meeting has already been created and reserved in the system, you cannot book it again',
        no_appoinment: 'No appoinment to generate meeting',
        meeting_created: 'Meeting created, dont change data of event please',
        select_option: 'Select option',
        doing_meeting: 'Doing meeting...',
        random_room: 'Autogenerated room',
        meeting_info: 'A meeting with the following data has been reserved:',
        subject: 'Subject',
        sip_uri: 'SIP Address',
        participant_booking_added: 'The participant {email} has been automatically added to the meeting. Do not remove it: doing so will prevent the meeting from being confirmed.',
        text_tip: 'Use your Outlook calendar to create professional video conferencing meetings.',
        more_info_url: 'For more information, please enter',
        contract: 'For information on how to contract the service, please enter',
        need_meeting_subject: 'Need a meeting subject',
        need_meeting_start: 'Need a meeting start date',
        need_meting_end: 'Need a meeting end date'
    },
    es: {
        title: 'Configura tu reunión TPaaS',
        need_login: 'Primero necesitas hacer login',
        username: 'Usuario',
        password: 'Password',
        login: 'Login',
        logout: 'Logout',
        use_this_room: 'Usar esta sala',
        record_meeting: 'Grabar reunión',
        call_members: 'Llamar a los participantes registrados',
        use_pin: 'Usar PIN para proteger mi reunión',
        participants: 'Participantes',
        create_meeting: 'Crear reunión de video',
        meeting_reserved: 'Esta reunión ya fue creada y reservada en el sistema, no puede reservarla nuevamente',
        no_appoinment: 'No hay evento disponible para generar la reunión',
        meeting_created: 'Reunión creada, por favor no cambie los datos del evento',
        select_option: 'Seleccionar una opción',
        doing_meeting: 'Generando reunión...',
        random_room: 'Sala autogenerada',
        meeting_info: 'Se ha reservado una reunión con los siguientes datos:',
        subject: 'Asunto',
        sip_uri: 'Dirección SIP',
        participant_booking_added: 'El participante {email} ha siño añadido automáticamente a la reunión. No lo elimine: de hacerlo la reunión no será confirmada.',
        text_tip: 'Utiliza tu calendario de Outlook para crear reuniones de video conferencia profesional.',
        more_info_url: 'Para obtener más información, acceda a',
        contract: 'Si desea información para contratar el servicio, acceda a',
        need_meeting_subject: 'Debe introducir el asunto de la reunión',
        need_meeting_start: 'Debe introducir la fecha de inicio',
        need_meting_end: 'Debe introducir la fecha de fin'
    },
    pt: {
        title: 'Configure sua reunião TPaaS',
        need_login: 'Primeiro deve logarse',
        username: 'Usuário',
        password: 'Senha',
        login: 'Login',
        logout: 'Logout',
        use_this_room: 'Usar esta sala',
        record_meeting: 'Gravar reunião',
        call_members: 'Chamar aos participantes registrados',
        use_pin: 'Usar PIN para proteger sua reunião',
        participants: 'Participantes',
        create_meeting: 'Criar reunião de vídeo',
        meeting_reserved: 'Esta reunião já  foi criada e reservada no sistema , não é possível reserva-la novamente',
        no_appoinment: 'Não há evento disponível para gerar a reunião',
        meeting_created: 'Reunião criada, por favor não mude os dados do evento',
        select_option: 'Escolher uma opção',
        doing_meeting: 'Gerando uma reunião...',
        random_room: 'Sala autogerada',
        meeting_info: 'Uma reunião foi gerada com os dados seguintes:',
        subject: 'Assunto',
        sip_uri: 'Endereço SIP',
        participant_booking_added: 'O participante {email} foi automaticamente incluído na reunião, não o elimine  para que a reunião possa ser confirmada pelo sistema.',
        text_tip: 'Usar o calendário outlook para criar reuniões de vídeo conferencia profissional.',
        more_info_url: 'Para mas informação acesse o',
        contract: 'Se deseja informação para contratar o serviço acesse',
        need_meeting_subject: 'Precisa de um assunto de reunião',
        need_meeting_start: 'Precisa de uma data de início da reunião',
        need_meting_end: 'Precisa de uma data de término da reunião'
    },
    it: {
        title: 'Organizza la tua riunione TPaaS',
        need_login: 'Per prima cosa devi effettuare l´accesso',
        username: 'Utente',
        password: 'Password',
        login: 'Login',
        logout: 'Logout',
        use_this_room: 'Usare questa stanza',
        record_meeting: 'Registra riunione',
        call_members: 'Chiamare partecipanti registrati',
        use_pin: 'Usare il PIN per proteggere la mia riunione',
        participants: 'Partecipanti',
        create_meeting: 'Creare riunione video',
        meeting_reserved: 'Questa riunione è già stata creata e prenotata nel sistema, non è possibile prenotarla di nuovo',
        no_appoinment: 'Non è disponibile alcun evento per generare la riunione',
        meeting_created: 'Riunione creata, per favore non modificare i dati dell´evento',
        select_option: 'Selezionare un´opzione',
        doing_meeting: 'Generando riunione ...',
        random_room: 'Stanza autogenerata',
        meeting_info: 'È stata prenotata una riunione con i seguenti dati:',
        subject: 'Oggetto',
        sip_uri: 'Indirizzo SIP',
        participant_booking_added: 'Il partecipante {email} è stato aggiunto automaticamente alla riunione, non eliminarlo in modo che la riunione possa essere confermata dal sistema.',
        text_tip: 'Utilizza il calendario di Outlook per creare riunioni di videoconferenza professionali.',
        more_info_url: 'Per ulteriori informazioni, accedere',
        contract: 'Se desidera informazione per contrattare il servizio, accedere',
        need_meeting_subject: 'Hai bisogno di un argomento di incontro',
        need_meeting_start: 'Hai bisogno di una data di inizio della riunione',
        need_meting_end: 'Hai bisogno di una data di fine della riunione'
    }
}

export default messages


// WEBPACK FOOTER //
// ./src/i18n/messages.js